export const vitaColors = [
    'Vita A1',
    'Vita A2',
    'Vita A3',
    'Vita A3.5',
    'Vita A4',
    'Vita B1',
    'Vita B2',
    'Vita B3',
    'Vita B4',
    'Vita C1',
    'Vita C2',
    'Vita C3',
    'Vita C4',
    'Vita D2',
    'Vita D3',
    'Vita D4',
];
